module.exports=function(scope){ return `<!-- enrollmentIdentifier or FaceMap missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "This endpoint requires valid 'enrollmentIdentifier' or 'faceMap' parameters to be passed."
    }
}

<!-- idScan missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "You must pass an idScan parameter."
    }
}

<!-- empty enrollmentIdentifier -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Empty string not valid for parameter enrollmentIdentifier"
    }
}

<!-- empty faceMap -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Empty string not valid for parameter FaceMap."
    }
}

<!-- faceMap is less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Source data length is < 20."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/failure/id-check.json.tpl